import React from "react";
import { Bar } from "react-chartjs-2";

class BarChart extends React.Component {
    render() {
        const { data, highlight, domain } = this.props;

        // calculate frequency of data
        var counts = {};
        for (var i = 0; i < data.length; i++)
            counts[data[i]] = counts[data[i]] + 1 || 1;

        // generate data
        const barDataValues = [];
        for (let i = 0; i < domain[1]; i++) {
            barDataValues.push(counts[i] || 0);
        }
        const barData = {
            labels: barDataValues.map((val, i) => i),
            datasets: [
                {
                    backgroundColor: barDataValues.map((val, i) =>
                        i >= highlight[0] && i <= highlight[1]
                            ? "rgba(251, 192, 45, 1)"
                            : "rgba(156, 39, 176, 0.2)"
                    ),
                    hoverBackgroundColor: "rgba(255,99,132,0.4)",
                    data: barDataValues
                }
            ]
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 0
            },
            plugins: {
                legend: {
                    display: false
                }
            },
            legend: {
                display: false
            },
            scales: {
                x: {
                        display: false
                    }
                ,
                y: 
                    {
                        display: false,
                    }
            }
        };
        return (
            <div style={{ "height":"100%", "position": "relative"}}>
                <Bar data={barData} options={options} />
            </div>
        );
    }
}

export default BarChart;
